/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {useNavigate} from 'react-router-dom'

const mappedLabel = (label: string): string => {
  if (label === '&laquo; Previous') {
    return 'Previous'
  }

  if (label === 'Next &raquo;') {
    return 'Next'
  }

  return label
}

const UsersListPagination = ({page, setPage, totalPages, loading, paginationDetails}: any) => {
  let startPage = Math.max(1, page - 3)
  let endPage = Math.min(totalPages, page + 3)
  let pages = []

  // Add previous 3 pages
  if (page - 3 > 1) {
    for (let i = startPage; i < page; i++) {
      pages.push(i)
    }
  } else {
    for (let i = 1; i < page; i++) {
      pages.push(i)
    }
  }

  // Add current page
  pages.push(page)

  // Add next 3 pages
  if (page + 3 < totalPages) {
    for (let i = page + 1; i <= endPage; i++) {
      pages.push(i)
    }
  } else {
    for (let i = page + 1; i <= totalPages; i++) {
      pages.push(i)
    }
  }

  const navigate = useNavigate()

  return (
    <div className='row'>
      <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>
      <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
        <div id='kt_table_users_paginate'>
          <ul className='pagination'>
            <li
              className={clsx('page-item', {
                disabled: loading || !paginationDetails?.hasPrevPage,
                previous: loading || paginationDetails?.hasPrevPage,
              })}
            >
              <a
                className='page-link'
                onClick={() => {
                  navigate(`/apps/agents/${page - 1}`)
                  setPage(page - 1)
                }}
                style={{cursor: 'pointer'}}
              >
                {mappedLabel('Previous')}
              </a>
            </li>

            {pages.map((item) => (
              <li
                key={item}
                className={clsx('page-item', {
                  active: item === page,
                })}
              >
                <a
                  className='page-link'
                  onClick={() => {
                    navigate(`/apps/agents/${item}`)
                    setPage(item)
                  }}
                  style={{cursor: 'pointer'}}
                >
                  {item}
                </a>
              </li>
            ))}

            <li
              className={clsx('page-item', {
                disabled: loading || !paginationDetails?.hasNextPage,
                next: loading || paginationDetails?.hasNextPage,
              })}
            >
              <a
                className='page-link'
                onClick={() => {
                  navigate(`/apps/agents/${page + 1}`)
                  setPage(page + 1)
                }}
                style={{cursor: 'pointer'}}
              >
                {mappedLabel('Next')}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export {UsersListPagination}
